
import { Component, OnInit , Input, ViewChild} from '@angular/core';

import { DatePipe } from '@angular/common';

import { PubSub } from 'aws-amplify';

import { MatAccordion } from '@angular/material/expansion';
import { Alarmas, AlarmasService } from 'src/app/services/alarmas.service';

import {MatDialog, MatDialogModule} from '@angular/material/dialog';
import { RegistroAlarmasComponent } from 'src/app/components/registro-alarmas/registro-alarmas.component';
import { DataRegistroAlarmas } from 'src/app/models/data-registo-alarmas';

const datePipe = new DatePipe('en-US');

//Opciones select
const disp1: string = "Disp1";
const disp2: string = "Disp2";
const disp3: string = "Disp3";
const disp1view: string = "Cama";
const disp2view: string = "Sillón";
const disp3view: string = "Frigorífico";

interface opcionSelect {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-tab-alarmas',
  templateUrl: './tab-alarmas.component.html',
  styleUrls: ['./tab-alarmas.component.scss'] 
})


export class TabAlarmasComponent implements OnInit {

  DEBUG: boolean = false;

 //cargamos los datos de la alarma
 @Input() arrayUser:any;

  constructor(
    private alarmaService: AlarmasService,
    public dialog: MatDialog
  ) {}
   
   // SELECT DISPOSITIVO
   opcionesDisp: opcionSelect[] = [
    { value: disp1,     viewValue: disp1view}, 
    { value: disp2,     viewValue: disp2view},
    { value: disp3,     viewValue: disp3view}
  ];
  selectOpcionDisp = this.opcionesDisp[0].value;
  selectedDisp = this.opcionesDisp[0].value;

  //SELECT EVENTO
  //EVENTO Cama
  opcionesEventCama: opcionSelect[] = [
    { value: "si se acuesta",       viewValue: "si se acuesta"},
    { value: "si no se acuesta",    viewValue: "si no se acuesta"}
  ];

  //EVENTO Sillon
  opcionesEventSillon: opcionSelect[] = [
    { value: "si se levanta",       viewValue: "si se levanta"},
    { value: "si no se levanta",    viewValue: "si no se levanta"}
  ];

  //EVENTO Frigorifico
  opcionesEventFridge: opcionSelect[] = [
    { value: "si se abre",       viewValue: "si se abre"},
    { value: "si no se abre",       viewValue: "si no se abre"},
    { value: "si hay alguien",    viewValue: "si hay alguien"},
  ];

   // SELECT 
   opcionesEvent: opcionSelect[] = [
    { value: "si se acuesta",       viewValue: "si se acuesta"},
    { value: "si no se acuesta",    viewValue: "si no se acuesta"},
    { value: "si se levanta",       viewValue: "si se levanta"},
    { value: "si no se levanta",    viewValue: "si no se levanta"}
  ];

  selectOpcionEvent = this.opcionesEventCama[0].value;
  selectedEvent = this.opcionesEventCama[0].value;

  panelOpenState = false;

  alarmList: Alarmas[] = [];
  registroAlarmaList: DataRegistroAlarmas[] = [];
  
  @ViewChild('accordion',{static: true}) Accordion: MatAccordion;
  
  carer: string = "master";
  patientID: string; //DNi del paciente userid (BBDD_AWS)

   addIdDist: string;
   addTipo: string;
   addHoraIni: string;
   addHoraFin: string;
   addEstado: boolean;

   lista: any;

   dispostivo: string;
   tipoDisp: string;
   DispActiv1: boolean = true;
   DispActiv2: boolean = false;
   DispActiv3: boolean = false;

//opciones Del componente Dist
  ngOnInit() {
    if(this.DEBUG){
      console.log("TAB ALARMAS: ");
      console.log("API - asyncMethodAlarms:");
      console.log(this.arrayUser);
    }
    this.patientID = this.arrayUser.userid;
    //recuperamos los datos guardados de ALARMAS ACTIVAS del dispositivo 1 por defecto
    this.getAlarm(this.arrayUser.disp1);
    this.dispostivo = this.arrayUser.disp1;
    this.actualizar();
  }

  ngOnDestroy() {
    if(this.DEBUG){
      console.log("DESTROY ALARMAS");
    }
  }


  actualizar(){
    switch(this.selectOpcionDisp) {
      case "Disp1": {
          // CARGAMOS LOS DATOS DEL DISPOSITIVO-1
          this.getAlarm(this.arrayUser.disp1);
          this.dispostivo = this.arrayUser.disp1;
          this.tipoDisp = disp1view;
        break; 
     }
      case "Disp2": {
          // CARGAMOS LOS DATOS DEL DISPOSITIVO-2
          this.getAlarm(this.arrayUser.disp2);
          this.dispostivo = this.arrayUser.disp2;
          this.tipoDisp = disp2view;
         break; 
      }
      case "Disp3": {
        // CARGAMOS LOS DATOS DEL DISPOSITIVO-3
        this.getAlarm(this.arrayUser.disp3);
        this.dispostivo = this.arrayUser.disp3;
        this.tipoDisp = disp3view;
       break; 
    }
      default: {
        //statements; 
        break; 
      }
    }

  }

  registroAlarmas(){
    const dialogRef = this.dialog.open(RegistroAlarmasComponent, {
      data: {data: this.arrayUser}
    });

    this.asyncMethodRegistroAlarmas(this.patientID, 0, 1);

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }

  async asyncMethodRegistroAlarmas(patientID: string, timeini:number, timefin:number){
    this.registroAlarmaList = await this.alarmaService.getRegistoAlarmas(patientID, timeini, timefin);

    console.log(this.registroAlarmaList)
  }

 onOptionDisp() {
  if(this.DEBUG){
    console.log('[SELECTOR]  onOptionDisp: ' + this.selectOpcionDisp);
  }
  switch(this.selectOpcionDisp) {
    case "Disp1": { 
        // CARGAMOS LOS DATOS DEL DISPOSITIVO-1
        this.getAlarm(this.arrayUser.disp1);
        this.dispostivo = this.arrayUser.disp1;
        this.tipoDisp = disp1view;
        this.DispActiv1 = true;
        this.DispActiv2 = false;
        this.DispActiv3 = false;
      break; 
   }
    case "Disp2": {
        // CARGAMOS LOS DATOS DEL DISPOSITIVO-2
        this.getAlarm(this.arrayUser.disp2);
        this.dispostivo = this.arrayUser.disp2;
        this.tipoDisp = disp2view;
        this.DispActiv1 = false;
        this.DispActiv2 = true;
        this.DispActiv3 = false;
       break; 
    }
    case "Disp3": {
      // CARGAMOS LOS DATOS DEL DISPOSITIVO-3
      this.getAlarm(this.arrayUser.disp3);
      this.dispostivo = this.arrayUser.disp3;
      this.tipoDisp = disp3view;
      this.DispActiv1 = false;
      this.DispActiv2 = false;
      this.DispActiv3 = true;
     break; 
  }
    default: {
      //statements; 
      break; 
    }
  }
}

  //opciones Del compoenete Dist
  OnOptionEvent() {
    if(this.DEBUG){
      console.log('Evento', this.addTipo);
    }
  }

  onTimeIni(event) {
    if(this.DEBUG){
      console.log('Fecha Inicial:', event);
    }
    this.addHoraIni  = event;
  }

  onTimeFin(event) {
    if(this.DEBUG){
      console.log('Fecha Final', event);
    }
    this.addHoraFin = event;
  }

  //acciones de los paneles
  beforePanelClosed(panel){
    //si se cierra el panel pone undefined los datos

    panel.isExpanded = false;
    console.log("Panel going to close!");
    
    this.addHoraIni = undefined;
    this.addHoraFin = undefined;
  }
  beforePanelOpened(panel){
    //Si se habre el panel copia los datos
    this.addTipo = panel.tipo;
    this.addHoraIni = undefined;
    this.addHoraFin = undefined;

    panel.isExpanded = true;
    console.log("Panel going to  open!");


    for (let i = 0; i < this.alarmList.length; i++) {
      if(panel.idpanel ==this.alarmList[i].idpanel ){
        this.alarmList[i].isExpanded = true;
      }else{
        this.alarmList[i].isExpanded = false;
      }
    }

  }

  afterPanelClosed(){
    console.log("Panel closed!");


  }
  afterPanelOpened(){
    console.log("Panel opened!");
  
  }


  closeAllPanels(){
    this.Accordion.closeAll();
  }
  openAllPanels(){
    this.Accordion.openAll();
  }

//----------------------------------------------   AÑADIR Y ACTUALIZAR/GUARDAR ALARMAS -------------------------------------------- 

  addAlarm(){
    // antes de añadir alarma Actualizamos la pantalla
    // this.actualizar();

    let idpanel = "panel0"; 
    let flagPanel = 0;


    for (let i = 0; i < this.alarmList.length; i++) {
      idpanel = "panel" + i;
      for(let j = 0; j < this.alarmList.length; j++){
        // console.log(idpanel);
        if(this.alarmList[i].espid == this.dispostivo && this.alarmList[j].idpanel == idpanel){
          flagPanel = 0;
          console.log("IGUAL - " + this.alarmList[j].idpanel + " - " + idpanel);
        }else{
          flagPanel = 1;
          console.log("No IGUAL - " + this.alarmList[j].idpanel + " - " + idpanel);
        }
      }

  }

  if(flagPanel == 0){
    idpanel = "panel"+(this.alarmList.length+1);
  }


  console.log(idpanel);

  switch(this.tipoDisp) {
    
    case disp1view: { 
      // CREAMOS ALARMA POR DEFECTO CAMA
      this.alarmList.push({
        espid: this.dispostivo, 
        idpanel:idpanel,
        carer: this.carer, // Al crearse por OHC pondemos que el usuario es MASTER
        patientID: this.patientID, //New
        isDisabled:false, 
        isExpanded:true,
        tipo: "si se levanta",
        horaIni: "00:00",
        horaFin: "00:00",
        estado: false,
      });

      console.log(this.alarmList);
      this.asyncMethodCreateAlarm(this.dispostivo, idpanel, this.carer, this.patientID, "00:00", "00:00", true, "si se levanta");
    break; 
    } 
    case disp2view: { 
      // CREAMOS ALARMA POR DEFECTO SILLON
      this.alarmList.push({
        espid: this.dispostivo, 
        idpanel:idpanel,
        carer: this.carer, // Al crearse por OHC pondemos que el usuario es MASTER
        patientID: this.patientID, //New
        isDisabled:false, 
        isExpanded:true,
        tipo: "si se levanta",
        horaIni: "00:00",
        horaFin: "00:00",
        estado: false,
      });

      console.log(this.alarmList);
      this.asyncMethodCreateAlarm(this.dispostivo, idpanel, this.carer, this.patientID, "00:00", "00:00", true, "si se levanta");
    break; 
    } 
    case disp3view: { 
      // CREAMOS ALARMA POR DEFECTO FRIGORIFICO
      this.alarmList.push({
        espid: this.dispostivo, 
        idpanel:idpanel,
        carer: this.carer, // Al crearse por OHC pondemos que el usuario es MASTER
        patientID: this.patientID, //New
        isDisabled:false, 
        isExpanded:true,
        tipo: "si se abre",
        horaIni: "00:00",
        horaFin: "00:00",
        estado: false,
      });

      console.log(this.alarmList);
      this.asyncMethodCreateAlarm(this.dispostivo, idpanel, this.carer, this.patientID, "00:00", "00:00", true, "si se abre");
    break; 
    } 
    default: { 
      //statements; 
      break; 
    } 

  }

  }

  async asyncMethodCreateAlarm(disp: string, idpanel: string, carer:string, patientID:string, horaIni: string, horaFin:string, estado:boolean, tipo: string){
    await this.alarmaService.createAlarma(this.dispostivo, idpanel, carer, patientID, horaIni, horaFin, estado, tipo);

  }



  saveAlarm(panel){
    //guardamos el panel en el acordeonList, eliminamos los datos y lo subimos
    if(this.DEBUG){
      console.log("Dispositivo: " + this.dispostivo);
      console.log("Id Panel: " + panel.idpanel);
      console.log("Tipo: " + this.addTipo);
    }

    if (this.addTipo == undefined){
      this.addTipo = panel.tipo;
    }else{
      panel.tipo = this.addTipo;
    }
    if(this.addHoraIni == undefined){
      this.addHoraIni = panel.horaIni;
    }else{
      panel.horaIni = this.addHoraIni;
    }
    if(this.addHoraFin == undefined){
      this.addHoraFin = panel.horaFin;
    }else{
      panel.horaFin = this.addHoraFin;
    }
    
    if(this.DEBUG){
      console.log("hora Ini: " + this.addHoraIni);
      console.log("hora Fin: " + this.addHoraFin);
      console.log("Estado: "   + panel.estado);   
      console.log("panel.horaIni: " + panel.horaIni);
      console.log("panel.horaFin: " + panel.horaFin);
    }

    this.asyncMethodSaveAlarm(this.dispostivo, panel.idpanel, this.carer, this.addHoraIni, this.addHoraFin, panel.estado, this.addTipo);

    this.addHoraIni = undefined;
    this.addHoraFin = undefined;

  }
  async asyncMethodSaveAlarm(disp: string, idpanel: string, carer: string, horaIni: string, horaFin:string, estado:boolean, tipo: string){
    // GUARDAMOS LOS DATOS DE LAS ALARMAS DE AWS 

    let crear: boolean = false;

    for (let i = 0; i < this.alarmList.length; i++) {
      // console.log(this.alarmList[i].espid + " " + idpanel);
      if(this.alarmList[i].espid == disp && this.alarmList[i].idpanel == idpanel){
        // ACTUALIZAMOS
        await this.alarmaService.updateAlarma(disp, idpanel, carer, horaIni, horaFin, estado, tipo);
        crear = false;
        break;
      }else{
        // CREAMOS
        crear = true;
      }

      if (crear){
        await this.alarmaService.createAlarma(this.dispostivo, idpanel, this.carer, this.patientID, horaIni, horaFin, estado, tipo);
      }else{
      }
    }



    }

  //----------------------------------------------   DELETE ALARMA ----------------------------------------------
  deleteAlarm(panel){
    if(this.DEBUG){
      console.log(panel);
      console.log("panel.id: " + panel.idpanel);
    }
    this.alarmList.forEach((value,index)=>{
      if(value.espid == this.dispostivo && value.idpanel == panel.idpanel){
        this.alarmList.splice(index, 1);
        if(this.DEBUG){
          console.log("Eliminamos: " + index);
        }
        this.asyncMethodDeleteAlarm(this.dispostivo, panel.idpanel);
      } else{
        if(this.DEBUG){
          console.log("No eliminado");
        }
      }
      });

      if(this.DEBUG){
        console.log(this.alarmList);
      }
  }

  async asyncMethodDeleteAlarm(disp: string, panel: string){
    await this.alarmaService.deleteAlarma(disp, panel);
  }

  //----------------------------------------------   GETS ALARMA ------------------------------------------------ 
  getAlarm(disp: string) {
  // RECUPERAMOS LOS DATOS DE LAS ALARMAS DE AWS
  // GET
  if(this.DEBUG){
    console.log('[getAlarm]  GET ALARMAS: ' + disp);
  }
  this.asyncMethodGetlarm(disp);

  }

  async asyncMethodGetlarm(disp: string){
  // GUARDAMOS LOS DATOS DE LAS ALARMAS DE AWS 

  this.alarmList = await this.alarmaService.getAlarmas(disp);
  // this.alarmList = this.arrayAlarms;

  }
    

}